import React from "react";
import { classes } from "./sitemenu.st.css";
// Component
import Nav from "../../../components/Nav/Nav";

const publicUrl = process.env.PUBLIC_URL;

const navLinks = [
  {
    linkText: "Layout",
    url: `${publicUrl}/`
  },
  {
    linkText: "Components",
    url: `${publicUrl}/components`
  },
  {
    linkText: "Examples",
    url: `${publicUrl}/examples`
  }
];

const SiteMenu = (props: any) => {
  return <Nav items={navLinks} className={classes.root} />;
};

export default SiteMenu;
